import { useState } from "react";
import {
  useModals,
  Modal,
  ModalProps,
  Button,
  Input,
  ListItem,
  Stack,
  Text,
} from "@skailer-com/uikit";
import { ServerErrorField } from "@/components/server-error-field/ServerErrorField.tsx";
import { useEmployeeTwoFactorDisable } from "@/queries/employees/use-employees.query.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

export function TwoFactorDisableModal(props: ModalProps) {
  const { id } = props;
  const { close } = useModals();
  const { t } = useTranslation();
  const twoFactorDisable = useEmployeeTwoFactorDisable();
  const [showCodeStep, setShowCodeStep] = useState(false);

  const connectSchemaObject = yup.object({
    code: yup.string().required(t("errors:field_required")),
  });

  type connectSchema = yup.InferType<typeof connectSchemaObject>;

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<connectSchema>({
    mode: "onSubmit",
    resolver: yupResolver(connectSchemaObject),
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      await twoFactorDisable.mutateAsync(data);

      analyticsService.trackEvent(analyticEvents.twoFactorAuthentication.disabled);

      close(id);
    } catch {}
  });

  return (
    <Modal withCloser title={t("core:two_factor")} {...props}>
      {showCodeStep ? (
        <form onSubmit={onSubmit}>
          <Stack gap={"md"}>
            <Input {...register("code")} autoFocus label={t("common:code")} required />
            <ServerErrorField errors={errors} />
            <Button onClick={onSubmit} size={"lg"} isLoading={twoFactorDisable.isPending}>
              {t("core:turn_off")}
            </Button>
          </Stack>
        </form>
      ) : (
        <Stack gap={"smd"}>
          <Text size={"xs"} className={"uppercase font-mono text-secondary"}>
            {t("core:want_less_security")}
          </Text>
          <ListItem
            titleSlot={
              <Text size={"md"} className={"text-alert font-semibold"}>
                {t("core:two_factor_disable")}
              </Text>
            }
            caption={t("core:two_factor_disable_caption")}
            valueSlot={
              <Button size={"md"} onClick={() => setShowCodeStep(true)}>
                {t("core:turn_off")}
              </Button>
            }
          />
        </Stack>
      )}
    </Modal>
  );
}
